var map = {
	"./account_circle.svg": 2065,
	"./add.svg": 2066,
	"./add_circle.svg": 2067,
	"./add_circle_outline.svg": 2068,
	"./arrow_back.svg": 2069,
	"./arrow_downward.svg": 2070,
	"./arrow_drop_down.svg": 2071,
	"./arrow_drop_left.svg": 2072,
	"./arrow_drop_right.svg": 2073,
	"./arrow_drop_up.svg": 2074,
	"./arrow_forward.svg": 2075,
	"./arrow_upward.svg": 2076,
	"./autorenew.svg": 2077,
	"./cached.svg": 2078,
	"./cancel.svg": 2079,
	"./chat.svg": 2080,
	"./check.svg": 2081,
	"./check_circle.svg": 2082,
	"./chevron_down.svg": 2083,
	"./chevron_left.svg": 2084,
	"./chevron_right.svg": 2085,
	"./chevron_up.svg": 2086,
	"./close.svg": 2087,
	"./close_circle_outline.svg": 2088,
	"./cloud_done.svg": 2089,
	"./cloud_download.svg": 2090,
	"./cloud_upload.svg": 2091,
	"./code.svg": 2092,
	"./compare_arrows_alt.svg": 2093,
	"./copy.svg": 2094,
	"./database.svg": 2095,
	"./done.svg": 2096,
	"./download.svg": 2097,
	"./error.svg": 2098,
	"./error_outline.svg": 2099,
	"./euro_symbol.svg": 2100,
	"./exit_to_app.svg": 2101,
	"./feedback.svg": 2102,
	"./filter_list.svg": 2103,
	"./format_align_center.svg": 2104,
	"./format_align_justify.svg": 2105,
	"./format_align_left.svg": 2106,
	"./format_align_right.svg": 2107,
	"./github.svg": 2108,
	"./grip.svg": 2109,
	"./help.svg": 2110,
	"./help_outline.svg": 2111,
	"./highlight.svg": 2112,
	"./highlight_off.svg": 2113,
	"./html5.svg": 2114,
	"./info.svg": 2115,
	"./info_outline.svg": 2116,
	"./laptop.svg": 2117,
	"./link.svg": 2118,
	"./menu.svg": 2119,
	"./mode_edit.svg": 2120,
	"./more_horiz.svg": 2121,
	"./more_vert.svg": 2122,
	"./notifications.svg": 2123,
	"./open_in_new.svg": 2124,
	"./pivotal_p.svg": 2125,
	"./pivotal_ui.svg": 2126,
	"./pivotal_ui_inverted.svg": 2127,
	"./pivotal_ui_white.svg": 2128,
	"./plug.svg": 2129,
	"./react.svg": 2130,
	"./refresh.svg": 2131,
	"./remove.svg": 2132,
	"./remove_circle.svg": 2133,
	"./remove_circle_outline.svg": 2134,
	"./report.svg": 2135,
	"./search.svg": 2136,
	"./select_chevrons.svg": 2137,
	"./smartphone.svg": 2138,
	"./sort.svg": 2139,
	"./spinner-md.svg": 2140,
	"./spinner-sm.svg": 2141,
	"./spinner.svg": 2142,
	"./upload.svg": 2143,
	"./vertical_align_bottom.svg": 2144,
	"./vertical_align_center.svg": 2145,
	"./vertical_align_top.svg": 2146,
	"./warning.svg": 2147,
	"./zoom_in.svg": 2148,
	"./zoom_out.svg": 2149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2064;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pui-css-iconography/svgs !./node_modules/babel-loader/lib!./node_modules/svg-react-loader/lib/loader.js ^\.\/.*\.svg$
// module id = 2064
// module chunks = 0